module.exports = __webpack_public_path__ + "img/boleto.d35330c.svg";